module.exports = {
   name: 'currency',
   gen_template: `
      {
         "coa": "ASSET",
         "code": "{{random.alphaNumeric}}{{random.number}}{{random.alphaNumeric}}{{random.number}}", 
         "name": "{{lorem.word}}"
      }
   `,
   wizard: {
      actionBtn: 'Save',
      action: 'currency_config',
      pages: [
         {
            title: 'Currency Config',
            subtitle: 'Configure new currency',
            forms: [
               {
                  type: 'text', form_type: 'text', label: 'Name', model: 'name',
                  validation: 'required|min:3|max:150', class: 'col-12'
               },
               {
                  type: 'text', form_type: 'text', label: 'Code', model: 'code',
                  validation: 'required|min:1|max:50', class: 'col-12 col-md-6'
               },
               {
                  type: 'text', form_type: 'text', label: 'ISO Code', model: 'iso_code',
                  validation: 'required|min:3|max:3', class: 'col-12 col-md-6'
               },
               {
                  type: 'text', form_type: 'text', label: 'Symbol', model: 'symbol',
                  validation: 'required|min:1|max:4', class: 'col-12 col-md-6'
               },
               {
                  type: 'text', form_type: 'text', label: 'Number Code', model: 'number',
                  validation: 'required|min:1|max:4|numeric', class: 'col-12 col-md-6'
               },
               {
                  type: 'textarea', form_type: 'text', label: 'Description', model: 'description',
                  validation: 'required|min:10|max:500', class: 'col-12'
               },
            ],
         }
      ]
   },
   table: {
      title: 'Currency Configs',
      subtitle: 'A list of configured currencies',
      table_fields: [
         { name: 'Code', align: 'l' },
         { name: 'Name', align: 'l' },
         { name: 'ISO Code', align: 'c' },
         { name: 'Symbol', align: 'c' },
         { name: 'actions', align: 'c' }
      ],
      searchFields: ["currency_code", "name", "currency_iso_code", "symbol"],
      rowData: [
         { type: 'text', field: 'currency_code', class: 'left small' },
         { type: 'text', field: 'name', class: 'left' },
         { type: 'text', field: 'currency_iso_code', class: 'center small' },
         { type: 'text', field: 'symbol', class: 'center small' },
         {
            type: 'action', field: 'name', class: 'center', icon: '', actions: [
               // {type: 'title', title: 'Actions'},
               {
                  type: 'menu', title: 'Edit', event: 'client:edit', icon: 'ico-right', params: [
                     { key: 'client', field: '*' }
                  ]
               },
               {
                  type: 'menu', title: 'View', event: 'client:view', icon: 'ico-reply', params: [
                     { key: 'email', field: 'email' },
                     { key: 'name', field: 'name' }
                  ]
               },
               // {type: 'divider'},
               {
                  type: 'menu', title: 'Delete', event: 'client:delete', icon: 'ico-mail-a', params: [
                     { key: 'email', field: 'email' }
                  ]
               },
            ]
         },
      ]
   },
}